// import { db } from "../../firebase";
// import { collection, addDoc, getDoc, getFirestore, doc } from "firebase/firestore";

import { db } from "../../firebase";
import { collection, addDoc, doc, serverTimestamp, getFirestore, onSnapshot, DocumentData, Unsubscribe } from "firebase/firestore";

async function subscribeUser(uid: string): Promise<string | null> {
	const checkoutSessionsCollection = collection(db, "customers", uid, "checkout_sessions");

	const docRef = await addDoc(checkoutSessionsCollection, {
		price: "price_1QzRZNAm2vpzKoGT5IBV2UAp", //"price_1QzJY2Am2vpzKoGTq7wJAvMR",
		trial_period_days: 7,
		allow_promotion_codes: true,
		automatic_tax: true,
		success_url: "https://control-room-react-app.web.app/home",
		cancel_url: window.location.origin,
		createdAt: serverTimestamp()
	});

	return new Promise((resolve, reject) => {
		let unsubscribe: Unsubscribe;
		unsubscribe = onSnapshot(
			docRef,
			(docSnap) => {
				const data: DocumentData | undefined = docSnap.data();
				if (data) {
					const { error, url } = data;
					if (error) {
						reject(new Error(`There was an error creating the checkout session: ${error}`));
						unsubscribe(); // Stop listening if there's an error
					} else if (url) {
						resolve(url);
						unsubscribe(); // Stop listening once the URL is found
					}
				} else {
					// Handle the case where data is null - maybe retry?
				}
			},
			(err) => {
				reject(err);
				unsubscribe();
			}
		);
	});
}

export { subscribeUser };

// async function subscribeUser(uid: string): Promise<string | null> {
// 	// const db = getFirestore(); // Explicitly get the Firestore instance
// 	const docRef = await addDoc(collection(db, "customers", uid, "checkout_sessions"), {
// 		price: "price_1QzJY2Am2vpzKoGTq7wJAvMR",
// 		success_url: window.location.origin,
// 		cancel_url: window.location.origin
// 	});

// 	const docSnap = await getDoc(docRef); // Await the result directly

// 	const data = docSnap.data();
// 	if (data) {
// 		const { error, url } = data;
// 		console.log("Error with Subscribe: ", error); // Improved logging
// 		console.log("URL past data: ", url); // Improved logging

// 		if (error) {
// 			console.error("There was an error going to checkout:", error); // Use console.error for errors
// 			return null;
// 		}

// 		if (url) {
// 			return url;
// 		} else {
// 			console.warn("URL was not found in the document data."); // Handle missing URL
// 			return null;
// 		}
// 	} else {
// 		console.warn("Document data was null or undefined."); // Handle null data
// 		return null;
// 	}
// }

// export { subscribeUser };

// import { db } from "../../firebase";
// import { collection, addDoc, getDoc } from "firebase/firestore";

// async function subscribeUser(uid) {
// 	const docRef = await addDoc(collection(db, "customers", uid, "checkout_sessions"), {
// 		price: "price_1QzJY2Am2vpzKoGTq7wJAvMR",
// 		success_url: window.location.origin,
// 		cancel_url: window.location.origin
// 	});

// 	// Wait for the CheckoutSession to get attached by the extension
// 	const docSnap = await getDoc(docRef).then(() => {
// 		const data = docSnap.data();
// 		console.log("data: " + JSON.stringify(data));
// 		if (data) {
// 			const { error, url } = data;
// 			console.log("Error with Subscribe: " + error);
// 			console.log("URL past data: " + url);
// 			if (error) {
// 				console.log("There was an error going to checkout: " + String(error));
// 				return null;
// 			}
// 			if (url) {
// 				// We have a Stripe Checkout URL, let's redirect.
// 				return url;
// 				// return url;
// 			}
// 		}
// 	});
// }

// export { subscribeUser };
